import React from 'react';
const CheckIcon = ({ color }) => {
    return (
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17.5" cy="17.5" r="17.5" transform="rotate(-180 17.5 17.5)" fill={color} />
            <path d="M13.5538 22.2876L9.3799 18.218C8.91078 17.7606 8.15298 17.7606 7.68387 18.218C7.21475 18.6754 7.21475 19.4142 7.68387 19.8716L12.7118 24.7739C13.1809 25.2313 13.9387 25.2313 14.4078 24.7739L27.1341 12.3658C27.6032 11.9084 27.6032 11.1696 27.1341 10.7122C26.665 10.2548 25.9071 10.2548 25.438 10.7122L13.5538 22.2876Z" fill="white" />
        </svg>

    );
}

export default CheckIcon;
